import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { MonthOptions, YearOptions } from "../config/functions";
import { Form, Row, Col, Button } from "react-bootstrap";
import "../styles/EmployeeReportFilter.css";

interface FilterProps {
  filters: {
    employeeId: string;
    year: string;
    // status: string;
  };
  onFilterChange: (filters: {
    employeeId: string;
    year: string;
    // status: string;
  }) => void;
  onReset: () => void;
}

const LeaveTransactionFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
}) => {
  const leaveList = useSelector((state: StoreState) => state.leaveRequest);
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  //   const statusOptions = [
  //     { id: "New", name: "New" },
  //     { id: "Approved", name: "Approved" },
  //   ];

  const yearOptions = YearOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));

  const filteredEmpLeave = leaveList.filter((item) => {
    // Use createTimestamp consistently with EmployeeSalaryPage because in parent we filter using timeStamp
    const date = new Date(item.createTimestamp ?? 0);
    const itemYear = date.getFullYear().toString();

    return (
      !localFilters.year || itemYear === localFilters.year
      //   && (!localFilters.status || item.status === localFilters.status)
    );
  });

  const employeeIds = filteredEmpLeave
    .map((s) => s.employeeId)
    .filter((id, index, self) => id && self.indexOf(id) === index);

  const uniqueEmployeeIds = employeeIds.map((id) => ({
    id,
    name: id.toString(),
  }));

  const handleInputChange = (name: string, value: string) => {
    setLocalFilters({ ...localFilters, [name]: value });
  };
  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );

  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {renderDropdown("Year", "year", localFilters.year, yearOptions)}

        {renderDropdown(
          "Employee ID",
          "employeeId",
          localFilters.employeeId,
          uniqueEmployeeIds,
        )}

        {/* {renderDropdown("Status", "status", localFilters.status, statusOptions)} */}

        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="mr-2"
            onClick={() => onFilterChange(localFilters)}
          >
            Find
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default LeaveTransactionFilter;
